import { FieldProps, getIn } from "formik";
import { OTPInput, REGEXP_ONLY_DIGITS_AND_CHARS } from "input-otp";

interface FormTwoFactorAuthProps extends FieldProps {
  label: string;
  handleOnComplete?: (value: string) => void;
}

function FormTwoFactorAuth({ form, field, label, handleOnComplete }: FormTwoFactorAuthProps) {
  const errors = getIn(form.errors, field.name);
  const touched = getIn(form.touched, field.name);

  return (
    <>
      {label ? (
        <label htmlFor={field.name} className="input-2fa__label">
          {label}
        </label>
      ) : null}

      <OTPInput
        autoFocus
        maxLength={6}
        containerClassName="input-2fa"
        onComplete={handleOnComplete ? (value: string) => handleOnComplete(value) : undefined}
        onChange={value => form.setFieldValue(field.name, value)}
        pattern={REGEXP_ONLY_DIGITS_AND_CHARS}
        render={({ slots }) => (
          <div className="input-2fa__container">
            {slots.map((slot, idx) => (
              <div
                className={`input-2fa__character ${
                  slot.placeholderChar ? "input-2fa__character--placeholder" : ""
                } ${slot.isActive ? "input-2fa__character--active" : ""}`}
                key={idx}
              >
                {slot.char ?? slot.placeholderChar}
                {slot.hasFakeCaret ? <div className="input-2fa__caret" /> : null}
              </div>
            ))}
          </div>
        )}
      />

      <p className="input-2fa__description">
        Please enter the two-factor authentication code that has been sent to you.
      </p>

      {touched && errors ? <p className="input__error">{errors}</p> : null}
    </>
  );
}

export default FormTwoFactorAuth;
